module.exports = __webpack_public_path__ + "static/media/tenant3-2.54cbbb4d.png";